import { referenceDataEditRules } from '@app/pcs/administration/models';
import { activityTypeBasic, activityTypeDetailed } from '@app/pcs/models/activity-type';
import { gql } from 'apollo-angular';

export const activityTypesSearchQuery = gql`
  query ActivityTypes ($searchContext: ReferenceDataSearchContextInput!) {
    activityTypes (searchContext: $searchContext) {
      ...activityTypeBasic
    }
  }
  ${activityTypeBasic}
`;

export const activityTypesWithEditRulesQuery = gql`
  query ActivityTypes ($searchContext: ReferenceDataSearchContextInput!, $userGridType: UserGridTypeInput) {
    activityTypes (searchContext: $searchContext) {
      ...activityTypeDetailed
    }
    referenceDataEditRules (searchContext: $searchContext) {
      ...referenceDataEditRules
    }
    userGridConfiguration (type: $userGridType) {
      configuration
    }
  }
  ${activityTypeDetailed}
  ${referenceDataEditRules}
`;

export const activityTypeQuery = gql`
  query ActivityType ($id: Long!) {
    activityType (id: $id) {
      ...activityTypeDetailed
    }
  }
  ${activityTypeDetailed}
`;

export const validateActivityTypeCodeQuery = gql`
  query ActivityType ($input: ValidateActivityTypeUniqueInput!) {
    validateActivityTypeCode (input: $input)
  }
`;
